export default "__VITE_ASSET__BJjbRKWN__"